<template>
    <div class="navbar">
        <div class="left-title">
            <img class="logo" src="../../assets/ZoomLogo.png">
        </div>
        <div class="right-menu">
            <!-- <zm-select v-model="namespace" class="navbar-select" placeholder="namespace" v-show="showNamespace" @change="setNamespace">
                <zm-option v-for="item in namespaceList" :key="item" :value="item"></zm-option>
            </zm-select> -->
            <!-- <zm-select v-model="filter.applicationId" class="navbar-select" placeholder="Application"
                clearable filterable @change="handelAppChange(true)" @focus="fetchApplication">
                <zm-option v-for="item in applicationList" :key="item.id" :label="item.applicationName" :value="item.id"></zm-option>
            </zm-select> -->
            <a href="https://zoomvideo.atlassian.net/wiki/spaces/ZW/pages/1316028494/CSMS+FAQ+EN" target="_blank" class="faq">
                <i class="zm-icon-help-outline" style="margin-bottom: 2px;"></i>
                FAQ
            </a>
            <zm-dropdown>
                <span class="zm-dropdown-link">
                    <i class="zm-icon-user"></i>
                    Hi, {{ username }}
                    <!-- <i class="zm-icon-user"></i> -->
                    <i class="zm-icon-down zm-icon--right"></i>
                </span>
                <zm-dropdown-menu slot="dropdown" :hide-timeout="350">
                    <zm-dropdown-item>
                        <span @click="logout()">Log Out</span>
                    </zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown>
        </div>
    </div>
</template>
<script>
import { listNamespace } from '@/api/index'
export default {
    data () {
        return {
            showNamespace: false,
            namespaceList: [],
            namespace: localStorage.namespace,
            username: localStorage.email
        }
    },
    created () {
        if (this.$route.name === 'Secret' || this.$route.name === 'Extend') {
            this.showNamespace = true
            this.fetchNamespace()
        }
    },
    watch: {
        $route () {
            if (this.$route.name === 'Secret' || this.$route.name === 'Extend') {
                this.showNamespace = true
                this.fetchNamespace()
            } else {
                this.showNamespace = false
            }
        }
    },
    methods: {
        fetchNamespace () {
            if (localStorage.namespaceList) {
                this.namespaceList = JSON.parse(localStorage.namespaceList)
            } else {
                listNamespace().then(response => {
                    this.namespaceList = response
                })
            }
        },
        setNamespace (val) {
            localStorage.namespace = val
            this.resetSetItem('namespace', this.value)
        },
        logout () {
            localStorage.token = ''
            localStorage.accessKey = ''
            localStorage.email = ''
            localStorage.application = ''
            if (localStorage.redirectUrl) {
                window.location.href = localStorage.redirectUrl
            } else {
                this.$router.push('/401')
            }
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 60px;
  width: 100%;
//   margin-left: 170px;
  position: fixed;
  background-color: #fff;
  z-index: 99;
//   top: 0;
//   left: 0px;
//   right: 0;
  border-radius: 0px !important;
  border-bottom: 1px solid #d8dce5;
  .left-title{
    float: left;
    height: 100%;
    line-height: 10px;
    // padding: 0 30px;
  }
  .right-menu {
    float: right;
    height: 100%;
    margin-right: 10px;
    line-height: 60px;
    &:focus{
     outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
    }
  }
}
.logo {
    height: 27px;
    padding-top: 20px;
    padding-left: 20px;
}
.navbar-select {
    line-height: 32px;
    margin-right: 10px;
}
.faq {
    margin-right: 10px;
    font-size: 14px;
    color: #000;
}
</style>
